import React from "react";

export default function Cell(props) {
    let {
        style = {},
        width = 0,
        className = "",
        border = false,
        double = false,
        grow = false, // new prop
    } = props;

    if (width) {
        style.width = width + "px";
    }

    if (grow) {
        style.flexGrow = 1;
    } else {
        style.flexGrow = 0;
    }

    let _class = "ui-cell";
    if (className) _class += " " + className;
    if (border) _class += " border";
    if (double) _class += " double";

    return (
        <div style={{ ...style }} className={_class}>
            {props.children}
        </div>
    );
}
